import type { WebinarSessionStatus } from '@/features/analytics/types';

export const NOT_STARTED_KPI_PLACEHOLDER = '—';

/**
 * Une session jamais lancée remonte dans les analytics une fois son créneau écoulé, avec des
 * indicateurs qui n'ont aucun sens : le taux de présence moyen calculé par le back vaut 100 %
 * faute de date de démarrage, et la durée affichée est celle autorisée par le forfait.
 */
export function isNotStartedSession(status: WebinarSessionStatus | null | undefined): boolean {
  return status === 'NOT_STARTED';
}

/**
 * Un compteur reste lisible à zéro (personne n'est venu) là où un taux ou une durée induit en
 * erreur : on le remplace alors par un tiret.
 */
export function resolveNotStartedKpiValue<T extends string | number>(
  value: T,
  status: WebinarSessionStatus | null | undefined,
): T | string {
  return isNotStartedSession(status) ? NOT_STARTED_KPI_PLACEHOLDER : value;
}

/**
 * Le rouge du taux de présence signale une contre-performance. Sur une session jamais lancée il
 * n'y a pas de performance à juger.
 */
export function resolvePresenceRateTone(
  presenceRatePercentage: number,
  status: WebinarSessionStatus | null | undefined,
): 'neutral' | 'success' | 'error' {
  if (isNotStartedSession(status)) return 'neutral';
  return presenceRatePercentage >= 50 ? 'success' : 'error';
}
